
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import dayjs from 'dayjs'

@Component
export class DateTimePicker extends Vue {
  @Prop({ default: () => { } }) defaultValue: any // { datetimeVal1, datetimeVal2 }
  @Prop({ default: '-' }) separator?: string // 开始日期与结束日期之间的分隔符
  @Prop({ default: '开始日期' }) placeholder1?: string // 开始日期占位符
  @Prop({ default: '结束日期' }) placeholder2?: string // 结束日期占位符
  @Prop({ default: 'date' }) type1: string // 开始日期类型可选值为 date time [datetime year-month回显没做兼容处理]
  @Prop({ default: 'date' }) type2: string // 结束日期类型可选值为 date time [datetime year-month回显没做兼容处理]
  @Prop({ default: new Date(dayjs().subtract(10, 'year').format('YYYY-MM-DD')) }) minDate: Date // 可选的最小时间
  @Prop({ default: new Date(dayjs().add(10, 'year').format('YYYY-MM-DD')) }) maxDate: Date // 可选的最大时间
  @Prop({ default: 0 }) minHour: number // 可选的最小小时，针对 time 类型
  @Prop({ default: 23 }) maxHour: number // 可选的最大小时，针对 time 类型
  @Prop({ default: 'YYYY年MM月DD日' }) ymDFormat: string // 年月日显示格式
  valueType = 0 // 0初始状态 1开始日期 2结束日期
  showDatetimePicker = false
  picker: any = {
    datetimeVal1: '',
    datetimeVal2: ''
  }
  curDate: any = new Date()

  @Watch('valueType')
  onValueTypeChange (newVal) {
    let { datetimeVal1, datetimeVal2 } = this.picker
    switch (newVal) {
      case 1: // 开始日期
        switch (this.type1) {
          case 'date': // 日期类型
            datetimeVal1 = this.formatDateTime(datetimeVal1)
            this.curDate = datetimeVal1 ? new Date(datetimeVal1) : new Date();
            // 回填今天的日期
            if (!datetimeVal1) {
              this.picker.datetimeVal1 = this.convertToArray(this.curDate, this.type1);
            }
            break;
          case 'time': // 时间类型
            this.curDate = datetimeVal1 ? this.formatDateTime(datetimeVal1) : (this.defaultValue.datetimeVal1 || dayjs().format('HH:mm'));
            // 回填defaultValue传入的默认值
            if (!datetimeVal1) {
              this.picker.datetimeVal1 = this.convertToArray(this.curDate, this.type1);
            }
            break;
          default:
            break;
        }
        break;

      case 2: // 结束日期
        switch (this.type2) {
          case 'date': // 日期类型
            datetimeVal2 = this.formatDateTime(datetimeVal2)
            this.curDate = datetimeVal2 ? new Date(datetimeVal2) : dayjs().endOf('month').toDate();
            // 回填本月最后一天的日期
            if (!datetimeVal2) {
              this.picker.datetimeVal2 = this.convertToArray(this.curDate, this.type2);
            }
            break;
          case 'time': // 时间类型
            this.curDate = datetimeVal2 ? this.formatDateTime(datetimeVal2) : (this.defaultValue.datetimeVal2 || dayjs().format('HH:mm'));
            // 回填defaultValue传入的默认值
            if (!datetimeVal2) {
              this.picker.datetimeVal2 = this.convertToArray(this.curDate, this.type2);
            }
            break;
          default:
            break;
        }
        break;
      default:
        break;
    }
  }

  initData ({ valueType = 1, showDatetimePicker = true, datetimeVal1, datetimeVal2 }) {
    this.valueType = valueType
    this.showDatetimePicker = showDatetimePicker
    this.picker.datetimeVal1 = datetimeVal1
    this.picker.datetimeVal2 = datetimeVal2
  }

  resetData () {
    this.valueType = 0
    this.showDatetimePicker = false
    this.picker.datetimeVal1 = ''
    this.picker.datetimeVal2 = ''
  }

  onSelectValue (type: number) {
    if (this.valueType == type && this.showDatetimePicker) {
      this.valueType = 0
      this.showDatetimePicker = false
      return false
    }
    this.valueType = type
    this.showDatetimePicker = true
  }

  onPickerChange (e: any) {
    const dateArray = e.getValues()
    if (this.valueType == 1) {
      this.picker.datetimeVal1 = dateArray
    } else if (this.valueType == 2) {
      this.picker.datetimeVal2 = dateArray
    }
  }

  // 格式化时间
  // dateArray 日期数组，月份要减1
  // yMDFormat 年月日显示格式
  // formatDateTime([2025, 11, 12, 13, 14], 'YYYY-MM-DD', 'HH:mm')
  formatDateTime (dateArray, yMDFormat = 'YYYY-MM-DD') {
    if (!Array.isArray(dateArray)) {
      return ''
    }
    let [year, month, date, hour, mimute] = dateArray;
    month = month - 1
    const length = dateArray.length;
    switch (length) {
      case 5:
        // [年,月,日,时,分] -> datetime
        return dayjs(new Date(year, month, date, hour, mimute)).format(`${yMDFormat} HH:mm`)
      case 3:
        // [年,月,日] -> date
        return dayjs(new Date(year, month, date)).format(yMDFormat)
      case 2:
        // 需要判断是 [年,月] 还是 [时,分]
        // 如果第一个元素是4位数字，认为是年份，否则认为是时间
        if (/^\d{4}$/.test(dateArray[0])) {
          let format = yMDFormat.split('DD')[0]
          format = format.slice(0, format.includes('年') ? format.length : format.length - 1)
          // [年,月] -> year-month
          return dayjs(new Date(year, month)).format(format)
        } else {
          // [时,分] -> time
          return `${dateArray[0]}:${dateArray[1]}`;
        }
      default:
        return '';
    }
  }

  convertToArray (dateString, type) {
    const date = dayjs(dateString);
    switch (type) {
      case 'datetime':
        return [
          date.year(),
          date.month() + 1,
          date.date(),
          date.hour(),
          date.minute()
        ]
      case 'date':
        return [
          date.year(),
          date.month() + 1,
          date.date()
        ]
      case 'year-month':
        return [
          date.year(),
          date.month() + 1
        ]
      case 'time':
        return [
          dateString.split(':')[0],
          dateString.split(':')[1]
        ]
      default:
        return []
    }
  }
}
export default DateTimePicker
